import { render } from "./MenuModal.vue?vue&type=template&id=d7731716"
import script from "./MenuModal.vue?vue&type=script&lang=js"
export * from "./MenuModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__